
import { instance as axios, Movimenta20Instance } from '../http'
import {
  ENDPOINT_CUSTOMER_ORDER,
  ENDPOINT_AVAILABLE_ORDER,
  ENDPOINT_DISPATCH_ORDER,
  ENDPOINT_CUSTOMER_ORDER_CHANGES_ACTIONS,
  ENDPOINT_ORDERS_CHANGES_ACTIONS,
  DOWNLOAD_CSV,
  ORDERS_SET_STATE_INPREPARATION,
  ENDPOINT_CARRIER_DISPATCH_ORDER
} from '../endpoints'

const qs = require('qs')

const URLS = {
  available: ENDPOINT_AVAILABLE_ORDER,
  dispatch: ENDPOINT_DISPATCH_ORDER
}

const getCustomerOrders = data => {
  const {
    supplierOrderCode,
    pyxisDateBegin,
    pyxisDateEnd,
    availabilityDateBegin,
    availabilityDateEnd,
    effectiveStatus,
    sort,
    ord,
    page
  } = data

  const params = {
    page: `${page}`,
    size: 13,
    sort: `${sort},${ord}`
  }

  let query = ''
  if (effectiveStatus) query += `effectiveStatus=${effectiveStatus}&`
  if (pyxisDateBegin) query += `orderDateFrom=${pyxisDateBegin}&orderDateTo=${pyxisDateEnd}&`
  if (availabilityDateBegin) query += `availableDateFrom=${availabilityDateBegin}&availableDateTo=${availabilityDateEnd}&`
  if (supplierOrderCode) params.supplierOrderCode = supplierOrderCode

  return axios.get(
    `${ENDPOINT_CUSTOMER_ORDER}?${query}queryParams= `,
    {
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
    }
  )
}

const getAvailableOrders = (data, type) => {
  const url = URLS[type]
  const {
    supplierOrderCode,
    effectiveStatus,
    sort,
    ord,
    page
  } = data

  const params = {
    page: `${page}`,
    size: 13,
    sort: `${sort},${ord}`
  }

  if (supplierOrderCode) params.supplierOrderCode = supplierOrderCode
  if (effectiveStatus) params.effectiveStatus = effectiveStatus
  if (!sort) delete params.sort

  return axios.get(
    `${url}?queryParams= `,
    {
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
    }
  )
}

const putSetStateInPreparation = body => axios.put(ORDERS_SET_STATE_INPREPARATION, body)

const getDownloadCsv = params => axios.get(DOWNLOAD_CSV, { responseType: 'blob', params })
const putEditOrders = body => axios.put(ENDPOINT_CUSTOMER_ORDER_CHANGES_ACTIONS, body)
const putEditOrdersStatus = body => axios.put(ENDPOINT_ORDERS_CHANGES_ACTIONS, body)

const postCarrierDispatchOrder = params => Movimenta20Instance.post(ENDPOINT_CARRIER_DISPATCH_ORDER, undefined, { params })

export default {
  getCustomerOrders,
  getAvailableOrders,
  putEditOrders,
  putEditOrdersStatus,
  getDownloadCsv,
  putSetStateInPreparation,
  postCarrierDispatchOrder
}



// WEBPACK FOOTER //
// ./src/repository/api/orders.js